import Stats from 'three/addons/libs/stats.module.js';

export class Debug {
	//create a singleton instance
	static #instance = null;
	static get Instance() {
		if (!Debug.#instance) {
			Debug.#instance = new Debug();
		}
		return Debug.#instance;
	}

	constructor() {
		this.times = {};
		window.debug = Debug;
	}

	setRenderer( renderer ) {
		this.renderer = renderer;
		this.#overrideRender(); 
	}

	#overrideRender() {
		const render = this.renderer.render;
		const that = this;
		this.renderer.render = ( scene, camera ) => {
			render.call( that.renderer, scene, camera );
			if( this.stats ) this.stats.update();
		};
	}

	start( name ) {
		if( !this.times[ name ] ) {
			this.times[ name ] = {
				sum: 0,
				last: 0,
				start: 0,
				stop: 0,
			};
		}
		this.times[ name ].start = performance.now();
	}

	stop( name ) {
		const stop = performance.now();
		if( !this.times[ name ] ) return;

		this.times[ name ].stop = stop;
		this.times[ name ].last = stop - this.times[ name ].start;
		this.times[ name ].sum += this.times[ name ].last;
	}

	log( renderer ) {
		const r = renderer || this.renderer;
		for( const name in this.times ) {
			console.log( `${name}: ${this.times[ name ].last}ms` );
		}
        
		if( r ) {
			console.log( 'Scene pointcount:', r.info.render.points );
			console.log( 'Scene linecount:', r.info.render.lines );
			console.log( 'Scene polycount:', r.info.render.triangles );
			console.log( 'Active Drawcalls:', r.info.render.calls );
			console.log( 'Textures in Memory', r.info.memory.textures );
			console.log( 'Programs in Memory', r.info.programs.map( p => p.name ) );
			console.log( 'Geometries in Memory', r.info.memory.geometries );
		}

		this.stats = new Stats();
		document.body.appendChild( this.stats.dom );
	}
}